const classnames = (...classes) => classes.filter((className) => !!className).join(' ');

export { classnames };
